import { useDispatch, useSelector } from 'react-redux';
import { change as changeFormValue } from 'redux-form';
import { getSelected } from '../utils/selection';
import PersuasionModalProvider from '../../common/context/PersuasionModalContext';
import SingleChoice from '../components/SingleChoice';
import ConfirmationModalProvider from '../../common/context/ConfirmationModalContext';
import { jsx as _jsx } from "react/jsx-runtime";
const PersuasionModalWrapper = props => {
  var _useSelector;
  const {
    form,
    productName
  } = props;
  const isSelected = (_useSelector = useSelector(state => getSelected(productName, form)(state))) !== null && _useSelector !== void 0 ? _useSelector : false;
  const dispatch = useDispatch();
  const setTravelerIds = value => dispatch(changeFormValue(form, `${productName}.travelerIds`, value));
  return /*#__PURE__*/_jsx(PersuasionModalProvider, {
    children: /*#__PURE__*/_jsx(ConfirmationModalProvider, {
      children: /*#__PURE__*/_jsx(SingleChoice, {
        ...props,
        isSelected: isSelected,
        setTravelerIds: setTravelerIds
      })
    })
  });
};
export default PersuasionModalWrapper;
//# sourceMappingURL=SingleChoiceContainer.js.map